{
  "addons.addonList": "Zoznam doplnkov",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Vytvorte a získajte svoj kľúč API z tohto odkazu",
  "addons.ambientWeatherDescription": "Ambient meteorologické stanice (Vantage Vue, Vantage Pro2, ...)",
  "addons.apiKey": "API kľúč",
  "addons.applicationKey": "Aplikačný kľúč",
  "addons.connect": "Pripojiť",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Kľúč API V2",
  "addons.davisDescription": "Davis meteorologické stanice (Vantage Vue, Vantage Pro2, ...)",
  "addons.davisRetrieveApiKey": "Získajte svoje kľúče API V2 z tohto odkazu",
  "addons.disconnect": "Odpojiť",
  "addons.ecowittCreateAndRetrieveKeys": "Vytvorte a získajte kľúč API aj kľúč aplikácie z tohto odkazu",
  "addons.ecowittDescription": "Ecowitt poskytuje profesionálnu wifi meteostanicu, bezdrôtové vnútorné a vonkajšie teplomery, monitory vlhkosti, vysoko presné dažďové meradlá, monitory kvality vzduchu a ďalšie.",
  "addons.helpLink": "",
  "addons.myAcuriteAccountOnHold": "Váš účet bol pozastavený. Ak chcete znova pripojiť svoj účet, zadajte svoje heslo",
  "addons.myAcuriteDescription": "AcuRite je značka číslo 1 v Severnej Amerike. Ako líder v technológii času, teploty a počasia vám AcuRite poskytuje podrobné informácie o vašom vnútornom a vonkajšom prostredí, aby ste si mohli s istotou naplánovať svoj deň.",
  "addons.myAcuriteEnterCredentials": "Zadajte svoje poverenia My AcuRite, aby ste prepojili svoj účet My AcuRite so SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Použite svoj termostat Netatmo na zmenu teploty vášho domova, či už z postele alebo z druhého konca sveta.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Vaša osobná meteorologická stanica doma",
  "addons.or": "alebo",
  "addons.providerAccountDisconnected": "Pripojenie k vašej meteorologickej službe vypršalo. Pre obnovenie aktualizácií údajov sa prosím znovu pripojte.",
  "addons.reconnect": "Znovu sa pripojte",
  "addons.weatherflowCreateToken": "Vytvorte a získajte svoj token z tohto odkazu",
  "addons.weatherflowTempestDescription": "Tempest Weather System so vstavaným meračom vetra a dažďovým meračom",
  "addons.wundergroundApiKey": "Kľúč API",
  "addons.wundergroundDescription": "Weather Underground je globálna komunita ľudí, ktorí spájajú údaje z environmentálnych senzorov, ako sú meteorologické stanice a monitory kvality ovzdušia, aby sme vám mohli poskytnúť bohaté, hyperlokálne údaje, ktoré potrebujete na to, aby ste podporili svoje vášne.",
  "addons.wundergroundRetrieveApiKey": "Získajte kľúč API z tohto odkazu",
  "addons.wundergroundRetrieveStationId": "Získajte ID svojej stanice z tohto odkazu",
  "addons.wundergroundStationId": "ID stanice",
  "airQuality.airQuality": "Kvalita ovzdušia",
  "airQuality.airQualityIndex": "Index kvality ovzdušia",
  "airQuality.co": "Oxid uhoľnatý",
  "airQuality.good": "Dobrá",
  "airQuality.goodDescription": "Kvalita ovzdušia sa považuje za uspokojivú a znečistenie ovzdušia predstavuje malé alebo žiadne riziko",
  "airQuality.hazardous": "Nebezpečná",
  "airQuality.hazardousDescription": "Zdravotné upozornenie: ktokoľvek môže pociťovať vážnejšie zdravotné účinky",
  "airQuality.indoorAirQuality": "Kvalita vnútorného vzduchu",
  "airQuality.moderate": "Priemerná",
  "airQuality.moderateDescription": "Kvalita vzduchu je prijateľná; pri niektorých znečisťujúcich látkach však môže existovať mierny zdravotný problém u veľmi malého počtu ľudí, ktorí sú nezvyčajne citliví na znečistenie ovzdušia.",
  "airQuality.no2": "Oxid dusičitý",
  "airQuality.o3": "Ozón",
  "airQuality.pm10": "Častice s priemerom 10 μm alebo menej",
  "airQuality.pm25": "Častice s priemerom 2,5 μm alebo menej",
  "airQuality.sensitiveUnhealthy": "Nezdravá pre citlivých ľudí",
  "airQuality.sensitiveUnhealthyDescription": "Členovia citlivých skupín môžu pociťovať zdravotné účinky. Širokej verejnosti sa to pravdepodobne nedotkne.",
  "airQuality.so2": "Oxid siričitý",
  "airQuality.unhealthy": "Nezdravá",
  "airQuality.unhealthyDescription": "Každý môže začať pociťovať účinky na zdravie; členovia citlivých skupín môžu pociťovať vážnejšie zdravotné účinky",
  "airQuality.veryUnhealthy": "Veľmi nezdravá",
  "airQuality.veryUnhealthyDezscription": "Zdravotné varovania pred núdzovými podmienkami. Je pravdepodobnejšie, že bude postihnutá celá populácia.",
  "alerts.addAlert": "Pridať upozornenie",
  "alerts.addCondition": "Pridať podmienku",
  "alerts.alertAdded": "Upozornenie bolo úspešne pridané",
  "alerts.alertAuthorizationNotice": "Upozornenia fungujú iba vtedy, ak povolíte SmartMixin na zobrazovanie upozornení",
  "alerts.alertDeleted": "Upozornenie bolo úspešne odstránené",
  "alerts.alertEdited": "Upozornenie bolo úspešne upravené",
  "alerts.alertName": "Názov upozornenia",
  "alerts.alertWhen": "Chcem byť upozornený, keď:",
  "alerts.aqiGreaterThan": "AQI viac ako",
  "alerts.aqiGreaterThanThreshold": "AQI je vyššie ako prahová hodnota {value}{unit}",
  "alerts.aqiLessThan": "AQI menej ako",
  "alerts.aqiLessThanThreshold": "AQI je menej ako prahová hodnota {value}{unit}",
  "alerts.atLeastOneCondition": "Musíte pridať aspoň jednu podmienku",
  "alerts.co2GreaterThan": "CO2 viac ako",
  "alerts.co2GreaterThanThreshold": "CO2 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.co2LessThan": "CO2 menej ako",
  "alerts.co2LessThanThreshold": "CO2 je menej ako prahová hodnota {value}{unit}",
  "alerts.conditions": "Podmienky",
  "alerts.createAlert": "Vytvoriť upozornenie",
  "alerts.dailyPrecipitationGreaterThan": "Denné zrážky väčšie ako",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Denné zrážky nad prahom {value}{unit}",
  "alerts.deleteAlert": "Odstrániť upozornenie",
  "alerts.editAlert": "Upraviť upozornenie",
  "alerts.editCondition": "Upraviť podmienku",
  "alerts.gustSpeedGreaterThan": "Rýchlosť nárazu väčšia ako",
  "alerts.gustSpeedGreaterThanThreshold": "Rýchlosť nárazu vetra je väčšia ako prahová hodnota {value}{unit}",
  "alerts.gustSpeedLessThan": "Rýchlosť nárazu menšia ako",
  "alerts.gustSpeedLessThanThreshold": "Rýchlosť nárazu vetra je nižšia ako prahová hodnota {value}{unit}",
  "alerts.heatIndexGreaterThan": "Tepelný index viac ako",
  "alerts.heatIndexGreaterThanThreshold": "Tepelný index je viac ako prahová hodnota {value}{unit}",
  "alerts.heatIndexLessThan": "Tepelný index menej ako",
  "alerts.heatIndexLessThanThreshold": "Tepelný index je menej ako prahová hodnota {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex viac ako",
  "alerts.humidexGreaterThanThreshold": "Humidex je viac ako prahová hodnota {value}{unit}",
  "alerts.humidexLessThan": "Humidex menej ako",
  "alerts.humidexLessThanThreshold": "Humidex je menej ako prahová hodnota {value}{unit}",
  "alerts.humidityGreaterThan": "Vlhkosť väčšia ako",
  "alerts.humidityGreaterThanThreshold": "Vlhkosť je vyššia ako prahová hodnota {value}{unit}",
  "alerts.humidityLessThan": "Vlhkosť menšia ako",
  "alerts.humidityLessThanThreshold": "Vlhkosť je nižšia ako prahová hodnota {value}{unit}",
  "alerts.inProgress": "Prebieha",
  "alerts.myAlerts": "Moje upozornenia",
  "alerts.noConfiguredAlert": "Zatiaľ nemáte nakonfigurované žiadne upozornenia, pridajte si ich",
  "alerts.noiseGreaterThan": "Hluk vyšší ako",
  "alerts.noiseGreaterThanThreshold": "Hluk je vyšší ako prahová hodnota {value}{unit}",
  "alerts.noiseLessThan": "Hluk nižší ako",
  "alerts.noiseLessThanThreshold": "Hluk nižší ako prahová hodnota {value}{unit}",
  "alerts.noteOnConditions": "Upozornenie sa spustí, keď sa overia všetky nižšie uvedené podmienky",
  "alerts.pm10GreaterThan": "PM 10 viac ako",
  "alerts.pm10GreaterThanThreshold": "PM 10 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm10LessThan": "PM 10 menej ako",
  "alerts.pm10LessThanThreshold": "PM 10 je menej ako prahová hodnota {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 viac ako",
  "alerts.pm1GreaterThanThreshold": "PM 1 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm1LessThan": "PM 1 menej ako",
  "alerts.pm1LessThanThreshold": "PM 1 je menej ako prahová hodnota {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 viac ako",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 je vyššie ako prahová hodnota {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 menej ako",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 je menej ako prahová hodnota {value}{unit}",
  "alerts.postStormSummary": "Súhrn po daždi",
  "alerts.postStormSynopsisHelper": "Po skončení každého dažďa dostanete súhrnné oznámenie.",
  "alerts.postStormSynopsisSoleCondition": "",
  "alerts.precipitationGreaterThan": "Hodinové zrážky väčšie ako",
  "alerts.precipitationGreaterThanThreshold": "Hodinové zrážky nad prahom {value}{unit}",
  "alerts.pressureGreaterThan": "Tlak väčší ako",
  "alerts.pressureGreaterThanThreshold": "Tlak je vyšší ako prahová hodnota {value}{unit}",
  "alerts.pressureLessThan": "Tlak menší ako",
  "alerts.pressureLessThanThreshold": "Tlak je nižší ako prahová hodnota {value}{unit}",
  "alerts.rainRateGreaterThan": "Intenzita dažďa väčšia ako",
  "alerts.rainRateGreaterThanThreshold": "Intenzita dažďa nad prahom {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Slnečné žiarenie väčšie ako",
  "alerts.solarRadiationGreaterThanThreshold": "Slnečné žiarenie je vyššie ako prahová hodnota {value}{unit}",
  "alerts.solarRadiationLessThan": "Slnečné žiarenie menej ako",
  "alerts.solarRadiationLessThanThreshold": "Slnečné žiarenie je nižšie ako prahová hodnota {value}{unit}",
  "alerts.temperatureGreaterThan": "Teplota vyššia ako",
  "alerts.temperatureGreaterThanThreshold": "Teplota je vyššia ako prahová hodnota {value}{unit}",
  "alerts.temperatureLessThan": "Teplota nižšia ako",
  "alerts.temperatureLessThanThreshold": "Teplota je nižšia ako prahová hodnota {value}{unit}",
  "alerts.thswGreaterThan": "THSW viac ako",
  "alerts.thswGreaterThanThreshold": "THSW je viac ako prahová hodnota {value}{unit}",
  "alerts.thswLessThan": "THSW menej ako",
  "alerts.thswLessThanThreshold": "THSW je menej ako prahová hodnota {value}{unit}",
  "alerts.thwGreaterThan": "THW viac ako",
  "alerts.thwGreaterThanThreshold": "THW je viac ako prahová hodnota {value}{unit}",
  "alerts.thwLessThan": "THW menej ako",
  "alerts.thwLessThanThreshold": "THW je menej ako prahová hodnota {value}{unit}",
  "alerts.uvGreaterThan": "UV index väčší ako",
  "alerts.uvGreaterThanThreshold": "UV index je vyšší ako prahová hodnota {value}{unit}",
  "alerts.uvLessThan": "UV index nižší ako",
  "alerts.uvLessThanThreshold": "UV index je nižší než prahová hodnota {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Viditeľnosť je väčšia ako prahová hodnota {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Viditeľnosť je nižšia ako prahová hodnota {value}{unit}",
  "alerts.visiblityGreaterThan": "Viditeľnosť väčšia ako",
  "alerts.visiblityLessThan": "Viditeľnosť menšia ako",
  "alerts.whichMeasure": "Na ktoré meranie chcete byť upozornení?",
  "alerts.whichModule": "Na ktorý modul by ste chceli byť upozornení?",
  "alerts.windChillGreaterThan": "Ochladenie vetra viac ako",
  "alerts.windChillGreaterThanThreshold": "Ochladenie vetra je viac ako prahová hodnota {value}{unit}",
  "alerts.windChillLessThan": "Ochladenie vetra menej ako",
  "alerts.windChillLessThanThreshold": "Ochladenie vetra je menej ako prahová hodnota {value}{unit}",
  "alerts.windSpeedGreaterThan": "Rýchlosť vetra väčšia ako",
  "alerts.windSpeedGreaterThanThreshold": "Rýchlosť vetra je väčšia ako prahová hodnota {value}{unit}",
  "alerts.windSpeedLessThan": "Rýchlosť vetra menšia ako",
  "alerts.windSpeedLessThanThreshold": "Rýchlosť vetra je nižšia ako prahová hodnota {value}{unit}",
  "astral.astronomicalSunPhase": "Astronomický {sunPhase}",
  "astral.civilSunPhase": "Občiansky {sunPhase}",
  "astral.dawn": "Svitanie",
  "astral.dusk": "Súmrak",
  "astral.firstQuarter": "Prvá štvrtina",
  "astral.fullMoon": "Spln",
  "astral.lastQuarter": "Posledná štvrtina",
  "astral.moon": "Fázy mesiaca",
  "astral.moonPhases": "Fázy Mesiaca",
  "astral.moonrise": "Východ Mesiaca",
  "astral.moonset": "Západ Mesiaca",
  "astral.nauticalSunPhase": "Námorná {sunPhase}",
  "astral.newMoon": "Nový Mesiac",
  "astral.noon": "Poludnie",
  "astral.remainingDaylight": "Zostávajúce denné svetlo",
  "astral.sunrise": "Východ slnka",
  "astral.sunriseAndSunset": "Východ a západ slnka",
  "astral.sunriseAt": "Východ slnka o {time}",
  "astral.sunset": "Západ slnka",
  "astral.sunsetAt": "Západ slnka o {time}",
  "astral.totalDaylight": "Celkové denné svetlo",
  "astral.waningCrescent": "Ubúdajúci polmesiac",
  "astral.waningGibbous": "Ubúdajúci mesiac",
  "astral.waxingCrescent": "Rastúci polmesiac",
  "astral.waxingGibbous": "Rastúci mesiac",
  "auth.alreadyHaveAccount": "Už máte účet?",
  "auth.authContainerTagline": "Váš osobný panel počasia. Pripojte svoje stanice a získajte údaje v reálnom čase na dosah ruky.",
  "auth.backToLogin": "Späť na prihlásenie",
  "auth.catchPhrase": "The Weather Intelligence Platform",
  "auth.checkYourEmail": "Skontrolujte svoj e-mail",
  "auth.continueWithApple": "Pokračovať cez Apple",
  "auth.continueWithFacebook": "Pokračovať cez Facebook",
  "auth.continueWithGoogle": "Pokračovať cez Google",
  "auth.email": "Emailová adresa",
  "auth.emailRequiredLoginFacebook": "Vyžaduje sa emailové povolenie.",
  "auth.emailVerification": "Overenie e-mailom",
  "auth.emailVerificationFailure": "Vyskytol sa problém s overením vášho emailu.",
  "auth.emailVerificationSuccess": "Váš email bol úspešne overený.",
  "auth.firstName": "Meno",
  "auth.forgotPassword": "Zabudli ste heslo?",
  "auth.forgotPasswordSubtitle": "Zadajte svoj e-mail a pošleme vám odkaz na resetovanie hesla.",
  "auth.lastName": "Priezvisko",
  "auth.login": "Prihlásiť sa",
  "auth.loginSubtitle": "Vitajte späť! Prosím, zadajte svoje údaje.",
  "auth.loginToSmartMixinDescription": "Ak chcete získať prístup k svojmu účtu, zadajte svoje poverenia SmartMixin.",
  "auth.logout": "Odhlásiť sa",
  "auth.logoutConfirmation": "Naozaj sa chcete odhlásiť?",
  "auth.noAccountYet": "Ešte nemáte účet?",
  "auth.or": "alebo",
  "auth.password": "Heslo",
  "auth.passwordAgain": "Opakovať heslo",
  "auth.passwordReset": "Resetovanie hesla",
  "auth.passwordResetSuccess": "Vaše heslo bolo úspešne aktualizované.",
  "auth.register": "Vytvoriť účet",
  "auth.registerDescription": "Vytvorte si bezplatný účet SmartMixin na pripojenie vašich meteorologických staníc, sledovanie údajov o počasí a prístup k výkonným analytickým nástrojom.",
  "auth.registerSubtitle": "Vytvorte si účet a začnite.",
  "auth.registerSuccess": "Úspešne ste sa zaregistrovali! Práve sme vám poslali overovací odkaz na adresu {emailAddress} s ďalšími pokynmi.",
  "auth.restorePassword": "Obnoviť heslo",
  "auth.restorePasswordSuccess": "Práve sme vám poslali odkaz na obnovenie hesla na adresu {emailAddress} s ďalšími pokynmi.",
  "auth.sendReset": "Odoslať pokyny na resetovanie",
  "auth.socialAccount": "alebo použite svoj účet",
  "auth.welcome": "Vitajte v SmartMixin",
  "auth.welcomeBack": "Vitajte späť!",
  "calendar.april": "Apríl",
  "calendar.august": "August",
  "calendar.dateFormat": "Formát dátumu",
  "calendar.day": "Deň",
  "calendar.december": "December",
  "calendar.end": "Ukončiť",
  "calendar.february": "Február",
  "calendar.hours": "Hodiny",
  "calendar.hoursShort": "h",
  "calendar.january": "Január",
  "calendar.july": "Júl",
  "calendar.june": "Jún",
  "calendar.last24Hours": "trvať 24 hodín",
  "calendar.last30Days": "posledných 30 dní",
  "calendar.last7Days": "posledných 7 dní",
  "calendar.march": "Marec",
  "calendar.max": "Max",
  "calendar.may": "Máj",
  "calendar.month": "Mesiac",
  "calendar.months": "mesiace",
  "calendar.november": "November",
  "calendar.october": "Október",
  "calendar.oneDay": "1-deň",
  "calendar.oneHour": "1-hodina",
  "calendar.oneMonth": "1-mesiac",
  "calendar.oneWeek": "1-týždeň",
  "calendar.previous24Hours": "Predchádzajúcich 24 hodín",
  "calendar.previous30Days": "Predchádzajúcich 30 dní",
  "calendar.previous7Days": "Predchádzajúcich 7 dní",
  "calendar.previousDay": "Predchádzajúci deň",
  "calendar.previousMonth": "Predchádzajúci mesiac",
  "calendar.previousWeek": "Predchádzajúci týždeň",
  "calendar.previousYear": "Predchádzajúci rok",
  "calendar.sameDayLastYear": "Ten istý deň minulého roku",
  "calendar.sameMonthLastYear": "Ten istý mesiac minulého roku",
  "calendar.selectADate": "Vyberte dátum",
  "calendar.selectAMonth": "Vyberte mesiac",
  "calendar.selectAYear": "Vyberte rok",
  "calendar.selectGranularity": "Vyberte podrobnosti",
  "calendar.selectTimescale": "Vyberte časové merítko",
  "calendar.september": "September",
  "calendar.sixHours": "6-hodín",
  "calendar.start": "Začiatok",
  "calendar.thirtyMinutes": "30-minút",
  "calendar.threeHours": "3-hodiny",
  "calendar.use24HourFormat": "Použiť 24-hodinový formát",
  "calendar.week": "Týždeň",
  "calendar.year": "Rok",
  "calendar.yesterday": "Včera",
  "common.accountDeleted": "Váš účet bol úspešne odstránený.",
  "common.accountOnHold": "Pripojenie vášho účtu vypršalo. Pre obnovenie aktualizácií údajov sa prosím znovu pripojte.",
  "common.add": "Pridať",
  "common.addAStation": "Pridať stanicu",
  "common.addToFavorites": "Pridať k obľúbeným",
  "common.addYourOwnStation": "Pridajte vlastnú stanicu",
  "common.alreadyPremium": "Už máte prémiový účet!",
  "common.alsoAvailableOn": "K dispozícii aj na:",
  "common.altitude": "Nadmorská výška",
  "common.analysis": "Analýzy",
  "common.aroundMe": "Okolo mňa",
  "common.articleCount": "{count, plural, one {count} článok} few {count} články} many {count} článkov} other {count} článkov}}",
  "common.articleNotFound": "Článok nenájdený",
  "common.articleNotFoundDescription": "Článok, ktorý hľadáte, neexistuje.",
  "common.average": "Priemerná",
  "common.averageOverThePeriod": "Priemer za dané obdobie",
  "common.away": "Preč",
  "common.back": "Späť",
  "common.backToHelpCenter": "Späť do centra pomoci",
  "common.backToHome": "Späť na Hlavnú Stránku",
  "common.bad": "Zlý",
  "common.batteryLevel": "Úroveň nabitia batérie",
  "common.bestValue": "Najlepšia Hodnota",
  "common.billingDetailsAndroid": "V prípade bezplatnej skúšobnej ponuky vám nebudú účtované žiadne poplatky, ak ju zrušíte 24 hodín pred uplynutím bezplatného úvodného obdobia. Po skončení skúšobnej verzie môžete predplatné SmartMixin kedykoľvek zrušiť prostredníctvom nastavení účtu Google Play, alebo sa automaticky obnoví. Musíte to urobiť 24 hodín pred koncom obdobia predplatného, aby ste sa vyhli účtovaniu ďalšieho poplatku uvedeného v tlačidle vyššie. Platby za predplatné budú účtované na váš účet Google Play pri potvrdení vášho nákupu a na začiatku každého obdobia obnovenia.",
  "common.billingDetailsIos": "V prípade bezplatnej skúšobnej ponuky vám nebudú účtované žiadne poplatky, ak ju zrušíte 24 hodín pred uplynutím bezplatného úvodného obdobia. Po skončení skúšobnej verzie môžete predplatné SmartMixin kedykoľvek zrušiť prostredníctvom nastavení účtu App Store, alebo sa automaticky obnoví. Musíte to urobiť 24 hodín pred koncom obdobia predplatného, aby ste sa vyhli účtovaniu ďalšieho poplatku uvedeného v tlačidle vyššie. Platby za predplatné budú účtované na váš účet App Store pri potvrdení vášho nákupu a na začiatku každého obdobia obnovenia.",
  "common.boilerOn": "Kotol ZAPNUTÝ",
  "common.browseByCategory": "Prechádzať podľa kategórie",
  "common.calendarView": "Zobrazenie kalendára",
  "common.cancel": "Zrušiť",
  "common.cannotBeEmpty": "Toto pole nemôže byť prázdne.",
  "common.cardDetails": "Podrobnosti karty",
  "common.categoryNotFound": "Kategória nenájdená",
  "common.categoryNotFoundDescription": "Táto kategória neexistuje alebo neobsahuje žiadne články.",
  "common.charts": "Grafy",
  "common.chartView": "Zobrazenie grafu",
  "common.clearRecentLocations": "Vyčistiť",
  "common.close": "Zavrieť",
  "common.comparison": "Porovnanie",
  "common.currentDay": "Aktuálny deň",
  "common.currentLocation": "Súčasná lokalita",
  "common.currentObservations": "Aktuálne hodnoty",
  "common.currentRainEvent": "Aktuálne dažďové udalosti",
  "common.currentRate": "Aktuálna sadzba",
  "common.currentWeatherConditions": "Súčasné podmienky",
  "common.customizeComparisonMetrics": "Prispôsobiť metriky",
  "common.customizeComparisonMetricsDescription": "Presuňte položky a znovu usporiadajte metriky porovnania. Klepnutím na ikonu oka môžete zobraziť alebo skryť metriky.",
  "common.customizeDashboard": "Prispôsobiť",
  "common.customizeDashboardDescription": "Potiahnutím položiek zmeníte poradie na nástenke. Klepnutím na ikonu oka zobrazíte alebo skryjete sekcie.",
  "common.customizedStationName": "Vlastný názov stanice",
  "common.dailyForecast": "Denná predpoveď",
  "common.dashboard": "Panel",
  "common.default": "Predvolené",
  "common.defaultForecastModelChip": "Predvolené · {name}",
  "common.delete": "Odstrániť",
  "common.deleteAccount": "Odstrániť účet",
  "common.deleteAccountConfirmation": "Naozaj chcete odstrániť svoj účet? Táto akcia je nezvratná.",
  "common.deleteAccountDescription": "Táto akcia odstráni váš účet a všetky vaše informácie. Už niet cesty späť.",
  "common.details": "Podrobnosti",
  "common.edit": "Upraviť",
  "common.editor": "Editor",
  "common.endTime": "Čas ukončenia",
  "common.exitFullscreen": "",
  "common.exploreWeatherMap": "Preskúmať Mapu Počasia",
  "common.favoriteLocations": "Obľúbené",
  "common.favoriteLocationsEmpty": "Môžete pridať až 5 obľúbených miest.",
  "common.favoriteStations": "Obľúbené stanice",
  "common.feedbackHelpsImprove": "Vaša spätná väzba nám pomáha zlepšovať naše články pomoci.",
  "common.filterStationDescription": "Nezobrazujte stanice s nespoľahlivými meraniami",
  "common.filterStations": "Filtrovať stanice",
  "common.filterStationSourceDescription": "Vyberte poskytovateľov staníc, ktorých chcete zobraziť na mape",
  "common.findStationsNearYou": "Nájsť stanice vo vašom okolí",
  "common.firmwareVersion": "Verzia firmvéru",
  "common.forecast": "Predpoveď",
  "common.forecastComparisonDescription": "Ľahko porovnávajte výstupy predpovedného modelu z viacerých zdrojov",
  "common.forecastModelComparison": "Porovnanie predpovedných modelov",
  "common.forecastModelCoverage": "Pokrytie",
  "common.forecastModelDescription": "Popis",
  "common.forecastModelDescription_AROME": "Vysokorozlišovací model Météo France umožňujúci riešenie konvekcie nad západnou Európou s rozlíšením 1,3 km. Najlepší vo svojej triede pre krátkodobé predpovede vo Francúzsku; aktualizuje sa každé tri hodiny.",
  "common.forecastModelDescription_ARPEGE_EU": "Európske hniezdo modelu ARPEGE Météo France s rozlíšením 10 km. Strednodobé predpovede nad Európou, aktualizované štyrikrát denne.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Globálny numerický model počasia Météo France s rozlíšením 25 km, bežiaci asi 4 dni. Aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_EC_GDPS": "Globálny deterministický predpovedný systém Environment Canada: svetový strednodobý model s rozlíšením 15 km bežiaci až 10 dní, aktualizovaný dvakrát denne.",
  "common.forecastModelDescription_EC_RDPS": "Regionálny deterministický predpovedný systém Environment Canada: strednodobý model nad Severnou Amerikou s rozlíšením 10 km, aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_GFS": "Vlajkový strednodobý globálny model NOAA. Pokrýva celú planétu s rozlíšením 25 km až do 16 dní, aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh NOAA: model umožňujúci riešenie konvekcie nad kontinentálnymi Spojenými štátmi s rozlíšením 3 km, aktualizovaný každú hodinu. Najvhodnejší pre veľmi krátkodobé predpovede búrok a silných meteorologických javov.",
  "common.forecastModelDescription_ICON_DE": "Vysokorozlišovací model DWD umožňujúci riešenie konvekcie nad Nemeckom a susednými krajinami s rozlíšením 2,2 km. Krátkodobé predpovede aktualizované dvakrát denne.",
  "common.forecastModelDescription_ICON_EU": "Európske hniezdo modelu ICON DWD s rozlíšením 7 km pokrývajúce Európu a severný Atlantik. Strednodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MET_NORWAY": "Otvorená služba predpovede počasia Nórskeho meteorologického ústavu, ktorá kombinuje severské modely s vysokým rozlíšením s údajmi ECMWF a poskytuje celosvetové predpovede až 10 dní dopredu.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Hniezdo AROME nad francúzskymi Antilami (Guadeloupe, Martinik) s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Hniezdo AROME nad Francúzskou Guyanou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Hniezdo AROME nad Novou Kaledóniou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Hniezdo AROME nad Francúzskou Polynéziou s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Hniezdo AROME nad Réunionom a Mayotte s rozlíšením 2,5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_NAM_CONUS": "Severoamerický mezoskalárny model NOAA nad kontinentálnymi Spojenými štátmi s rozlíšením 5 km. Krátkodobé predpovede aktualizované štyrikrát denne.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Severoamerický mezoskalárny model NOAA pokrývajúci celú Severnú Ameriku s rozlíšením 32 km. Aktualizovaný štyrikrát denne.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Vlajková predpoveď SmartMixin. Pre každú hodinu na vašom mieste vyberáme najlepší dostupný model — zvyčajne vysokorozlišovací regionálny model tam, kde existuje (AROME vo Francúzsku, ICON-D2 v Nemecku, HRRR v USA, ARPEGE Europe naprieč kontinentom…) a inde sa vraciame ku globálnemu modelu — potom zaplníme akékoľvek medzery zo susedných zdrojov. Výsledkom je jediná bezproblémová predpoveď pokrývajúca kdekoľvek na svete až 14 dní, automaticky aktualizovaná vždy, keď je niektorý zo základných modelov aktualizovaný.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Vlastná globálna predpoveď Weatherflow, ktorá kombinuje viacero numerických modelov počasia s pozorovaniami zo siete meteorologických staníc Tempest. Celosvetový 10-dňový horizont.",
  "common.forecastModelDetailTitle": "Predpovedný model",
  "common.forecastModelScopeGlobal": "Globálny",
  "common.forecastModelScopeGlobalDescription": "Tento model pokrýva celú planétu.",
  "common.forecastModelScopeRegional": "Regionálny",
  "common.forecastModelScopeRegionalDescription": "Tento model pokrýva iba určitý región.",
  "common.forecastModelSpecifications": "Špecifikácie",
  "common.forecastSources": "Zdroje predpovedí",
  "common.freeAccount": "Bezplatný účet",
  "common.freeSubscription": "Bezplatné prémiové predplatné",
  "common.freeTrialForPeriod": "Bezplatná skúšobná verzia na {period} dní",
  "common.frequency": "Frekvencia",
  "common.full": "Plný",
  "common.fullscreen": "",
  "common.getStartedFree": "Začať Zadarmo",
  "common.getUnlimitedAccess": "Neobmedzený prístup k:",
  "common.good": "Dobrý",
  "common.help": "Pomocník",
  "common.helpCategoryAccount": "Účet",
  "common.helpCategoryBilling": "Fakturácia",
  "common.helpCategoryGettingStarted": "Začíname",
  "common.helpCategoryProviders": "Poskytovatelia",
  "common.helpCategoryStations": "Stanice",
  "common.helpCategoryTroubleshooting": "Riešenie problémov",
  "common.helpCenter": "Centrum pomoci",
  "common.helpCenterDescription": "Nájdite odpovede na časté otázky a zistite, ako čo najlepšie využiť SmartMixin.",
  "common.hg": "Ochrana pred mrazom",
  "common.hidden": "Skryté",
  "common.hiddenSensors": "Skryté senzory",
  "common.hiddenStations": "Skryté stanice",
  "common.hiddenStationsDescription": "Stanicu môžete odblokovať klepnutím na ikonu oka vedľa nej.",
  "common.high": "Vysoký",
  "common.home": "Domov",
  "common.homeConnectService": "Vlastníte meteostanicu? Pripojte svoju službu",
  "common.homeInformation": "Domáce informácie",
  "common.homeIntroduction": "Začnite pripájať svoje externé účty a vychutnajte si funkcie SmartMixin.",
  "common.homeName": "Názov domova",
  "common.homeSubtitle": "Vaše počasie, všetko na jednom mieste",
  "common.horizon": "Horizont",
  "common.horizonValue": "až do {value} hodín",
  "common.iDontKnowYet": "Ešte neviem",
  "common.indoor": "Interiér",
  "common.lastRainEvent": "Posledné dažďové udalosti",
  "common.lastUpdate": "Posledná aktualizácia",
  "common.loading": "Načítava sa",
  "common.location": "Miesto",
  "common.locationAddedToFavorites": "Poloha pridaná do obľúbených položiek",
  "common.locationNotGranted": "Povolenie na umiestnenie nie je udelené. Umožnite prístup k vašej polohe v nastaveniach zariadenia.",
  "common.locationRemovedFromFavorites": "Poloha odstránená z obľúbených položiek",
  "common.locations": "Miesta",
  "common.low": "Nízke",
  "common.manage": "Spravovať",
  "common.manageAccount": "Spravovať účet",
  "common.manageMySubscription": "Spravovať moje predplatné",
  "common.manageSensors": "Správa senzorov",
  "common.manageSensorsDescription": "Presuňte položky pre zmenu poradia senzorov. Klepnite na ikonu oka pre zobrazenie alebo skrytie senzorov. Klepnite na názov pre jeho premenovanie.",
  "common.manualBoost": "Manuálne zvýšenie",
  "common.manualSetpointUntil": "Manuálna nastavená hodnota do",
  "common.maxFavoriteLocationsReached": "Môžete mať iba až 5 obľúbených miest. Odstráňte jeden a pridajte ďalší.",
  "common.measureToDisplay": "Merania na zobrazenie",
  "common.medium": "Stredné",
  "common.meshSize": "Veľkosť mriežky",
  "common.minRead": "{minutes} min čítania",
  "common.modifyFavoriteStations": "Upraviť obľúbené stanice",
  "common.modifyFavoriteStationsDescription": "Môžete objednať svoje obľúbené stanice ich pretiahnutím. Môžete ich tiež odstrániť zo zoznamu.",
  "common.moduleType": "Typ modulu",
  "common.monthTotal": "Celkovo za mesiac",
  "common.more": "Viac",
  "common.moreInformation": "Viac informácií",
  "common.myLocation": "Moja poloha",
  "common.nearbyWeatherStations": "Blízke meteorologické stanice",
  "common.next": "Najbližší",
  "common.nextHours": "Hodinová predpoveď",
  "common.no": "Nie",
  "common.noAccountNeeded": "Bez nutnosti účtu",
  "common.noDataForThisPeriod": "Žiadne údaje za toto obdobie",
  "common.noLocationsFound": "Žiadne miesta nenájdené",
  "common.noNetatmoWeatherStationYet": "Ešte nemáte meteorologickú stanicu Netatmo.",
  "common.noOutdoorModule": "Pre túto stanicu nie je funkčný vonkajší modul.",
  "common.noStationsFound": "Žiadne stanice nenájdené",
  "common.noThermostatYet": "Ešte nemáte termostat.",
  "common.notNow": "Nie teraz",
  "common.notPurchasedYet": "Zdá sa, že toto ešte nebolo zakúpené.",
  "common.noWeatherStation": "Žiadna meteorologická stanica",
  "common.noWeatherStationYet": "Ešte nemáte meteorologickú stanicu.",
  "common.numberOfActiveWarnings": "{warning_count} aktívne varovania o počasí",
  "common.openSettings": "Otvorené nastavenia",
  "common.orChooseMonthly": "Alebo zvoľte mesačne:",
  "common.outdatedModule": "Údaje tohto modulu sú neaktuálne.",
  "common.outdoor": "Exteriér",
  "common.outdoorTemperature": "Vonkajšia teplota",
  "common.pageNotFound": "Stránka Nenájdená",
  "common.pageNotFoundDescription": "Stránka, ktorú hľadáte, neexistuje alebo bola presunutá.",
  "common.passwordUpdated": "Heslo bolo úspešne aktualizované.",
  "common.personalWeatherIntelligence": "Vaša Osobná Meteorologická Inteligencia",
  "common.premiumAccount": "Prémiový účet",
  "common.premiumDescription": "Prémiové predplatné odomkne mnoho ďalších funkcií, ako je pokročilá analýza počasia, porovnania máp, modely regionálnej predpovede a mnohé ďalšie.",
  "common.premiumFeatureAlerts": "Výstrahy Počasia",
  "common.premiumFeatureAnalysis": "Pokročilá Analýza Počasia",
  "common.premiumFeatureCharts": "Porovnanie Grafov",
  "common.premiumFeatureExport": "Export Dát",
  "common.premiumFeatureForecast": "Regionálne Predpovedné Modely",
  "common.premiumFeatureNotification": "Widget Stavového Riadku",
  "common.premiumFeatureTitle": "Prémiová Funkcia",
  "common.premiumFeatureWidgets": "Widgety domovskej obrazovky",
  "common.pressureSummary": "Tlak sumár",
  "common.previous": "Predchádzajúci",
  "common.previousHours": "Predchádzajúce hodiny",
  "common.profileUpdated": "Profil bol úspešne aktualizovaný.",
  "common.purchasedNetatmoPro": "V minulosti ste si zakúpili Netatmo Pro ({date}). Poskytuje vám prístup k podmnožine prémiových funkcií. Ak chcete mať prístup ku všetkým prémiovým funkciám, prihláste sa na odber jednej z nasledujúcich ponúk.",
  "common.rain": "Dážď",
  "common.rainEvents": "Dažďové udalosti",
  "common.rainfallMeasurement": "Meranie zrážok",
  "common.rainRadar": "Dažďový radar",
  "common.rainRadarDescription": "Zobrazte na mape prekrytie dažďového radaru",
  "common.rainSummary": "Dážď sumár",
  "common.range": "Rozsah",
  "common.recentLocations": "Posledný",
  "common.recentLocationsEmpty": "Tvoj nedávna história je prázdna.",
  "common.recentStations": "Nedávne stanice",
  "common.relatedArticles": "Súvisiace články",
  "common.relay": "Relé",
  "common.removeFromFavorites": "Odstrániť z obľúbených",
  "common.renameSensors": "Premenovať senzory",
  "common.resetZoom": "Obnoviť priblíženie",
  "common.restorePurchase": "Obnoviť nákup",
  "common.room": "Miestnosť",
  "common.rooms": "Miestnosti",
  "common.savingsPercent": "Ušetríte {percent}%",
  "common.searchArticles": "Hľadať články...",
  "common.searchForALocation": "Hľadať miesto...",
  "common.searchForLocation": "Vyhľadajte miesto",
  "common.searchForWeatherStation": "Vyhľadajte meteorologickú stanicu",
  "common.searchResults": "Výsledky vyhľadávania",
  "common.searchResultsEmpty": "Nezistili sa žiadne výsledky.",
  "common.searchStationsDescription": "Zadajte mesto, adresu alebo názov miesta pre nájdenie meteorologických staníc v okolí.",
  "common.searchStationsHint": "Použite vyhľadávacie pole vyššie na objavenie meteorologických staníc kdekoľvek na svete.",
  "common.selectStationForComparison": "Vyberte stanicu na porovnanie",
  "common.selectWeatherForecastProvider": "Prosím, vyberte poskytovateľa počasia",
  "common.serialNumber": "Sériové číslo",
  "common.share": "Zdieľať",
  "common.shareOutdoorMeasures": "Zdieľajte svoje vonkajšie merania",
  "common.shareOutdoorMeasuresDescription": "Zapojte sa do komunity SmartMixin tým, že zviditeľníte svoje vonkajšie merania pre ostatných. Vnútorné merania nebudú nikdy zdieľané.",
  "common.shareYourWeather": "Zdieľajte počasie",
  "common.signalStrength": "Sila signálu",
  "common.skip": "Preskočiť",
  "common.smartThermostat": "Inteligentný termostat",
  "common.smartValve": "Inteligentný ventil",
  "common.snow": "Sneh",
  "common.start": "Štart",
  "common.startFreeTrial": "Začať Bezplatnú Skúšobnú Verziu",
  "common.startTime": "Čas spustenia",
  "common.station": "stanica",
  "common.stationAddedToFavorites": "Stanica bola pridaná medzi obľúbené",
  "common.stationComparison": "Porovnanie staníc",
  "common.stationComparisonDescription": "Porovnajte historické údaje o počasí s inou stanicou",
  "common.stationInformation": "Informácie o stanici",
  "common.stationName": "Názov stanice",
  "common.stationObservationsDescription": "Zobrazte najnovšie pozorovania z meteorologických staníc",
  "common.stationRemovedFromFavorites": "Stanica bola odstránená z obľúbených",
  "common.stations": "stanice",
  "common.stationsNear": "Stanice v okolí",
  "common.stationType": "Typ stanice",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Zastarané",
  "common.statusSyncing": "Synchronizácia",
  "common.subscribeNow": "Predplatiť teraz - bez skúšobnej doby",
  "common.sumOverThePeriod": "Kumulované za dané obdobie",
  "common.switchToPremium": "Prejdite na SmartMixin Premium",
  "common.temperatureShort": "Tepl.",
  "common.temperatureSummary": "Teplota sumár",
  "common.thankYouForFeedback": "Ďakujeme za vašu spätnú väzbu!",
  "common.thenPrice": "potom {price}",
  "common.timeSelection": "Časový výber",
  "common.timezone": "Časové pásmo",
  "common.totalDuration": "Dĺžka celkovo",
  "common.tryAnotherLocation": "Nepodarilo sa nám nájsť žiadne meteorologické stanice v blízkosti tohto miesta. Skúste hľadať v inej oblasti.",
  "common.unknown": "Neznámy",
  "common.untilChanged": "Až do zmeny",
  "common.untilTime": "Do {time}",
  "common.upgrade": "Aktualizácia",
  "common.upgradeRequiredAndroid": "Vyžaduje sa aktualizácia. Navštívte Google Play a aktualizujte aplikáciu na najnovšiu verziu",
  "common.upgradeRequiredIos": "Vyžaduje sa aktualizácia. Navštívte App Store a aktualizujte aplikáciu na najnovšiu verziu",
  "common.validate": "Overiť",
  "common.validEmail": "Vyžaduje sa platná e-mailová adresa.",
  "common.very_low": "Veľmi nízke",
  "common.visitNetatmoWebsite": "Navštívte webovú stránku Netatmo",
  "common.wasArticleHelpful": "Bol tento článok užitočný?",
  "common.weatherCondition": "Meteorologické podmienky",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain je dodatočný zdroj údajov poskytovaný prostredníctvom systému Tempest Weather System, ktorý využíva technológiu Nearcast. Údaje NC Rain sú odhadom priemernej akumulácie zrážok okolo vášho Tempestu na úrovni susedstva",
  "common.weatherForecastModels": "Modely predpovedí počasia",
  "common.weatherIntelligencePlatform": "Platforma Meteorologickej Inteligencie",
  "common.weatherMap": "Mapa počasia",
  "common.weatherMapMetaDescription": "SmartMixin ponúka interaktívne mapy počasia a radaru pre poveternostné podmienky po celom svete.",
  "common.weatherObservations": "Pozorovania počasia",
  "common.weatherStation": "Meteorologická stanica",
  "common.weatherStations": "Meteorologické stanice",
  "common.welcome": "Vitajte v SmartMixin!",
  "common.whenBackHome": "Kedy sa vrátite domov?",
  "common.wifiStrength": "Sila WiFi signálu",
  "common.wind": "Vietor",
  "common.windMeasurement": "Meranie vetra",
  "common.windSpeed": "Rýchlosť vetra",
  "common.windSummary": "Vietor sumár",
  "common.yearToDate": "Rok do dňa",
  "common.yes": "Áno",
  "intro.locationDescription": "Povoľte prístup k polohe, aby ste získali presné predpovede prispôsobené vašej presnej oblasti — žiadne univerzálne predpovede.",
  "intro.locationTitle": "Predpovede vytvorené pre vás",
  "intro.notificationDescription": "Zapnite upozornenia, aby ste dostávali včasné upozornenia na zmeny počasia, ktoré sú pre vás dôležité — dážď, sneh alebo extrémne podmienky, práve keď to potrebujete vedieť.",
  "intro.notificationsTitle": "Nikdy nezmeškajte zmenu počasia",
  "intro.readyDescription": "Užite si presné predpovede, aktuálne meteorologické informácie a dáta zo staníc po celom svete — všetko v jednej výkonej aplikácii.",
  "intro.readyTitle": "Ste pripravení!",
  "intro.welcomeDescription": "Získajte hyperlokálne predpovede od popredných meteorologických agentúr — plus prístup k viac ako 40 000 meteorologickým staniciam po celom svete, aby ste videli reálne podmienky, minulé aj súčasné.",
  "intro.welcomeTitle": "Vaše počasie, prepracované",
  "landing.alerts": "Upozornenia",
  "landing.alertsDescription": "Vytvorte si vlastné upozornenia a získajte upozornenia hneď, ako sa spustia.",
  "landing.featureAlertsDescription": "Nastavte si vlastné upozornenia pre podmienky, ktoré vás zaujímajú—teplota, vietor, zrážky a ďalšie.",
  "landing.featureAlertsTitle": "Inteligentné upozornenia",
  "landing.featureAnalyticsDescription": "Ponorte sa do svojich dát pomocou interaktívnych grafov, porovnaní vedľa seba a analýzy trendov presahujúcej základné metriky.",
  "landing.featureAnalyticsTitle": "Výkonná analytika",
  "landing.featureExportDescription": "Stiahnite si svoje dáta vo formáte CSV pre analýzu v Exceli, integráciu s inými systémami alebo zálohu.",
  "landing.featureExportTitle": "Export kamkoľvek",
  "landing.featureForecastDescription": "Porovnajte predpovede z viac ako 10 meteorologických modelov vrátane GFS, ECMWF, ICON a ďalších, aby ste videli, ktorý funguje najlepšie pre vašu lokalitu.",
  "landing.featureForecastTitle": "Porovnanie predpovedí",
  "landing.featureHistoryDescription": "Prístup k historickým dátam v hodinovej, dennej a mesačnej mierke. Export do CSV pre výskum alebo osobné archívy.",
  "landing.featureHistoryTitle": "Bohatá história",
  "landing.featureMultiBrandDescription": "Pripojte stanice od Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow a ďalších—všetko v jednom dashboarde.",
  "landing.featureMultiBrandTitle": "Podpora viacerých značiek",
  "landing.featuresSubtitle": "Navrhnuté pre nadšencov do počasia, ktorí vyžadujú viac ako základnú aplikáciu meteorologickej stanice.",
  "landing.featuresTitle": "Všetko, čo potrebujete na analýzu počasia",
  "landing.finalCtaButton": "Vytvoriť účet zadarmo",
  "landing.finalCtaSubtitle": "Pripojte sa k tisícom nadšencov do počasia, ktorí dôverujú SmartMixinu so svojimi meteorologickými dátami.",
  "landing.finalCtaTitle": "Pripravení vylepšiť svoje počasie?",
  "landing.forecastDescription": "Získajte prístup k niektorým z najlepších modelov predpovedí počasia a porovnajte ich, aby ste získali vlastnú predstavu o počasí.",
  "landing.forecasts": "Predpovede",
  "landing.heroCta": "Začať zadarmo",
  "landing.heroDescription": "Spojte viacero meteorologických staníc ľubovoľnej značky, porovnávajte predpovedné modely a analyzujte svoje dáta pomocou podrobných grafov a exportov.",
  "landing.heroSecondaryCta": "Zobraziť funkcie",
  "landing.heroTagline": "The Weather Intelligence Platform",
  "landing.heroTitle": "Všetky meteorologické dáta. Jedna platforma.",
  "landing.pricingFeatureAdvancedMetrics": "Pokročilé metriky",
  "landing.pricingFeatureAlerts": "Vlastné upozornenia",
  "landing.pricingFeatureExport": "Export dát (CSV)",
  "landing.pricingFeatureForecastComparison": "Porovnanie predpovedí",
  "landing.pricingFeatureForecasts": "Predpovedné modely",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "Všetky modely (10+)",
  "landing.pricingFeatureReports": "Analýzy a správy",
  "landing.pricingFeatureStationComparison": "Porovnanie staníc",
  "landing.pricingFeatureWidgets": "Widgety na domovskej obrazovke",
  "landing.pricingFeatureYearOverYear": "Medziроčná analýza",
  "landing.pricingFree": "Zadarmo",
  "landing.pricingFreeCta": "Začať",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Najobľúbenejší",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Začať",
  "landing.pricingPremiumDescription": "Od 1,99 €/mesiac — predplaťte si na webe, App Store alebo Google Play",
  "landing.pricingSubtitle": "Začnite zadarmo, upgradujte keď potrebujete viac.",
  "landing.pricingTitle": "Jednoduchý, transparentný cenník",
  "landing.smartMixinDescription": "SmartMixin je aplikácia, ktorá poskytuje prístup k vašej meteorologickej stanici a viac ako 40 000 ďalším staniciam po celom svete. Pomáha vám vidieť a porozumieť údajom o počasí.",
  "landing.statBrands": "Podporované značky",
  "landing.statForecasts": "Predpovedných modelov",
  "landing.statStations": "Pripojených staníc",
  "landing.supportedDevices": "Podporované zariadenia",
  "landing.supportedDevicesDescription": "Okrem staníc Svetovej meteorologickej organizácie podporuje SmartMixin rastúci počet značiek meteorologických staníc.",
  "landing.supportedDevicesNote": "Pripojte meteorologické stanice popredných značiek a zobrazte všetky dáta na jednom mieste.",
  "landing.supportedDevicesSubtitle": "Pripojte meteorologické stanice popredných značiek a zobrazte všetky dáta na jednom mieste.",
  "landing.supportedDevicesTitle": "Funguje s vašimi stanicami",
  "landing.thermostatDescription": "Použite svoj termostat Netatmo na zmenu teploty vášho domova, či už z postele alebo z druhého konca sveta.",
  "landing.thermostatManufacturers": "Výrobcovia termostatov sú tiež podporovaní, aby korelovali vykurovanie s vonkajšími podmienkami.",
  "landing.thermostatTitle": "Netatmo Thermostat",
  "landing.weatherAnalysis": "Analýza počasia",
  "landing.weatherAnalysisDescription": "SmartMix prichádza s množstvom vizualizácií údajov, ktoré vám umožňujú analyzovať údaje o počasí.",
  "landing.weatherAssistant": "Váš asistent počasia",
  "landing.weatherAssistantDescription": "Či už vás zaujímajú aktuálne, historické alebo predpovedané poveternostné podmienky, SmartMixin poskytuje množstvo informácií, kedykoľvek ich potrebujete.",
  "landing.weatherForecastModels": "Modely predpovedí počasia",
  "landing.weatherForecastModelsDescription": "SmartMixin poskytuje prístup k najpresnejším modelom predpovede počasia. Môžete ľahko porovnať ich prognózy a urobiť si vlastnú predstavu.",
  "landing.weatherMap": "Mapa počasia",
  "landing.weatherMapDescription": "Prehliadnite si mapu a predstavte si, aké je počasie kdekoľvek na svete.",
  "network.cancelError": "Požiadavka bola zrušená",
  "network.connectionError": "Server nie je k dispozícii",
  "network.networkError": "Sieť nie je k dispozícii",
  "network.serverError": "Niečo sa pokazilo...",
  "network.timeoutError": "Časový limit pripojenia vypršal",
  "network.unknownError": "Neznáma chyba",
  "providerHints.ambientWeatherApiKey": "Vytvorené v nastaveniach vášho účtu na ambientweather.net.",
  "providerHints.davisApiSecret": "Zobrazí sa iba raz pri vytvorení V2 API kľúča — uchovajte v bezpečí.",
  "providerHints.davisV2ApiKey": "Zo stránky V2 API kľúčov na weatherlink.com.",
  "providerHints.ecowittApi": "Zo stránky API vášho účtu Ecowitt.",
  "providerHints.ecowittApp": "Kľúč aplikácie, tiež z vášho účtu Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Použite e-mail a heslo vášho účtu My AcuRite — nie prihlásenie do SmartMixin.",
  "providerHints.myAcuriteEmail": "E-mail vášho účtu My AcuRite — nie vaše prihlásenie do SmartMixin.",
  "providerHints.myAcuritePassword": "Heslo vášho účtu My AcuRite.",
  "providerHints.weatherflowToken": "Osobný token z tempestwx.com → nastavenia → autorizácie údajov.",
  "providerHints.wundergroundEditKey": "Použiť iný kľúč",
  "providerHints.wundergroundKey": "Dlhý reťazec zo stránky API kľúčov vášho účtu Weather Underground — nie vaše heslo na wunderground.com.",
  "providerHints.wundergroundKeyExample": "napr. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API kľúč overený",
  "providerHints.wundergroundKeyVerifying": "Overovanie kľúča…",
  "providerHints.wundergroundNoStationsNearby": "V okolí tejto lokality neboli nájdené žiadne stanice. Skúste zadať ID stanice priamo.",
  "providerHints.wundergroundStationId": "Akékoľvek ID stanice Weather Underground — vaše vlastné alebo verejná stanica vo vašom okolí.",
  "providerHints.wundergroundStationIdExample": "napr. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Získajte svoj API kľúč Ambient Weather.",
  "providerIntro.davisStep2": "Získajte svoj V2 API kľúč a API tajomstvo Davis.",
  "providerIntro.ecowittStep2": "Získajte svoj API kľúč a kľúč aplikácie Ecowitt.",
  "providerIntro.getStarted": "Začať",
  "providerIntro.myAcuriteStep2": "Použite e-mail a heslo vášho existujúceho účtu My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Prihláste sa do Netatmo, keď budete vyzvaní — API kľúč nie je potrebný.",
  "providerIntro.netatmoWeatherStep2": "Prihláste sa do Netatmo, keď budete vyzvaní — API kľúč nie je potrebný.",
  "providerIntro.signupBanner": "Takmer hotovo — vytvorte si bezplatný účet SmartMixin na pripojenie {provider}.",
  "providerIntro.step1": "Prihláste sa do svojho účtu SmartMixin (NIE do {provider}).",
  "providerIntro.step3EmailPassword": "Zadajte sem.",
  "providerIntro.step3KeyOrToken": "Vložte sem.",
  "providerIntro.step3OAuth": "Autorizujte SmartMixin vo vyskakovacom okne.",
  "providerIntro.step3Wunderground": "Vložte svoj API kľúč a potom vyberte stanicu v okolí alebo zadajte ľubovoľné ID stanice.",
  "providerIntro.title": "Pripojiť {provider}",
  "providerIntro.weatherflowStep2": "Získajte svoj osobný Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemáte stanicu? Prehliadajte verejné",
  "providerIntro.wundergroundFindNearby": "Nájsť stanice v okolí",
  "providerIntro.wundergroundOrEnterId": "Alebo zadať ID stanice",
  "providerIntro.wundergroundStep2": "Získajte svoj API kľúč Weather Underground. Potom budete môcť pripojiť akúkoľvek stanicu — vlastnú alebo verejnú.",
  "reports.agroMeteorology": "Agrometeorológia",
  "reports.analysis": "Analýzy",
  "reports.annualCumulativeRainfallComparison": "Ročné kumulatívne porovnanie zrážok",
  "reports.annualHeatingDurationComparison": "Porovnanie doby vykurovania za rok",
  "reports.annualHeatingEfficiency": "Ročná efektivita vykurovania",
  "reports.annualIndoorComparison": "Ročné porovnanie - interiér",
  "reports.annualIndoorReport": "Výročná správa - interiér",
  "reports.annualOutdoorComparison": "Ročné porovnanie - exteriér",
  "reports.annualOutdoorReport": "Výročná správa - exteriér",
  "reports.annualReport": "Výročná správa",
  "reports.annualSolarReport": "Výročná solárna správa",
  "reports.annualWaterBalance": "Ročná vodná bilancia",
  "reports.annualWaterBalanceCarryOver": "",
  "reports.annualWaterBalanceDescription": "Vodná bilancia (zjednodušená verzia, používa sa len dážď a evapotranspirácia) pomáha riadiť zásobovanie vodou",
  "reports.avgHumidity": "Priemerná vlhkosť",
  "reports.avgMaxTemperature": "Priemerná T°max",
  "reports.avgMinTemperature": "Priemerná T°min",
  "reports.avgPressure": "Priemerný tlak",
  "reports.avgTemperature": "Priemerná teplota",
  "reports.comfortable": "Komfortné (45 % {lessThan} vlhkosť ≤ 60 %)",
  "reports.cumulativeRainfall": "Kumulatívne zrážky",
  "reports.cumulativeRainfallDescription": "Sledujte celkové zrážky nahromadené za zvolené obdobie.",
  "reports.dailyMaxRainfall": "Max. denné zrážky",
  "reports.dataExport": "Export údajov",
  "reports.dataExportXlsxFormatDescription": "Exportujte všetky údaje vašej stanice vo formáte Excel (*.xlsx). Po kliknutí na tlačidlo vám po niekoľkých minútach príde email so spracovanými údajmi.",
  "reports.daysWithFrost": "Mrazivé dni",
  "reports.daysWithoutThaw": "Dni bez odmäku",
  "reports.daysWithStrongFrost": "Dni zo silným mrazom",
  "reports.emailSent": "E-mail bol odoslaný do vašej poštovej schránky",
  "reports.grasslandTemperatureSum": "Súčet teploty trávnatých plôch",
  "reports.grasslandTemperatureSumDescription": "Ak sa na jar prekročí súčet {threshold}, dosiahol sa udržateľný začiatok vegetácie (funguje v Európe)",
  "reports.growingDegreeDays": "Rastové stupňodni",
  "reports.highPressure": "Tlaková výš (priemerný tlak ≥ 1013 mbar)",
  "reports.indoorReport": "Správa o interiéri",
  "reports.keyFacts": "Kľúčové fakty",
  "reports.longestRunOfRainyDays": "Najdlhší priebeh daždivých dní",
  "reports.longestRunWithoutRun": "Najdlhší priebeh dní bez dažďa",
  "reports.lowPressure": "Tlaková níž (priemerný tlak < 1013 mbar)",
  "reports.maxHumidity": "Maximálna vlhkosť",
  "reports.maxPressure": "Maximálny tlak",
  "reports.maxPressureMagnitude24h": "Maximálna magnitúda (/24H)",
  "reports.maxTemperature": "Maximálna teplota",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximálna magnitúda (/24H)",
  "reports.minHumidity": "Minimálna vlhkosť",
  "reports.minPressure": "Minimálny tlak",
  "reports.minPressureMagnitude24h": "Minimálna magnitúda (/24H)",
  "reports.minTemperature": "Minimálna teplota",
  "reports.minTempMagnitude24h": "Minimálna magnitúda (/24H)",
  "reports.monthlyHeatingEfficiency": "Mesačná efektivita vykurovania",
  "reports.monthlyIndoorReport": "Mesačná správa interiér",
  "reports.monthlyOutdoorReport": "Mesačná správa exteriér",
  "reports.monthlyReport": "Mesačná správa",
  "reports.monthlySolarReport": "Mesačná solárna správa",
  "reports.monthlyWindReport": "Mesačná správa o vetre",
  "reports.numberOfDays": "Počet dní",
  "reports.outdoorReport": "Správa o exteriéri",
  "reports.rainfall": "Zrážky",
  "reports.rainyDays": "Daždivé dni",
  "reports.relativelyWet": "Nadmerne vlhké (60 % < Vlhkosť ≤ 80 %)",
  "reports.sendEmail": "Odoslať email",
  "reports.tooDry": "Príliš suché (Vlhkosť ≤ 45%)",
  "reports.tooWet": "Príliš vlhké (Vlhkosť > 80 %)",
  "reports.tropicalNights": "Tropické noci",
  "reports.waterBalance": "Vodná bilancia",
  "reports.yearToDateTemperature": "Aktuálna teplota",
  "reports.yearToDateTemperatureComparison": "Porovnanie teplôt medzi rokmi",
  "sensors.aqiByChannel": "AQI podľa kanálu",
  "sensors.bgtSensors": "Čierna guľa a WBGT",
  "sensors.cameraFeed": "",
  "sensors.compareAqi": "Porovnať AQI",
  "sensors.compareHumidity": "Porovnať vlhkosť",
  "sensors.compareMoisture": "Porovnať vlhkosť pôdy",
  "sensors.comparePm25": "Porovnať PM2.5",
  "sensors.compareTemperatures": "Porovnať teploty",
  "sensors.depthByChannel": "Hĺbka podľa kanála",
  "sensors.heatStressExtreme": "Extrémny tepelný stres",
  "sensors.heatStressModerate": "Mierny tepelný stres",
  "sensors.heatStressNone": "Žiadny tepelný stres",
  "sensors.heatStressStrong": "Silný tepelný stres",
  "sensors.heatStressVeryStrong": "Veľmi silný tepelný stres",
  "sensors.humidityByChannel": "Vlhkosť podľa kanálu",
  "sensors.indoorAirQuality": "Kvalita vnútorného vzduchu",
  "sensors.indoorAirQualityPm": "PM2.5 a PM10 AQI",
  "sensors.indoorClimate": "Vnútorná klíma",
  "sensors.indoorCo2Levels": "Úrovne CO2",
  "sensors.indoorTemperatureAndHumidity": "Teplota a vlhkosť",
  "sensors.last24Hours": "24 hodín",
  "sensors.last30Days": "30 dní",
  "sensors.last7Days": "7 dní",
  "sensors.leafTemperatureByChannel": "Teplota listov podľa kanálu",
  "sensors.leafWetnessByChannel": "Vlhkosť listov podľa kanálu",
  "sensors.lightningSensor": "Blesk",
  "sensors.moistureByChannel": "Vlhkosť pôdy podľa kanálu",
  "sensors.noDataAvailable": "Žiadne dáta nie sú k dispozícii",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 podľa kanálu",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Vyberte kanál",
  "sensors.sensorDetailDescription": "Zobrazenie historických údajov a trendov pre kanály senzora.",
  "sensors.sensorHistory": "História senzora",
  "sensors.soilTemperatureByChannel": "Teplota pôdy podľa kanálu",
  "sensors.strikesToday": "Údery dnes",
  "sensors.temperatureByChannel": "Teplota podľa kanálu",
  "settings.about": "O aplikácii",
  "settings.aboutDescription": "Licenčná zmluva, zásady ochrany súkromia",
  "settings.account": "Účet",
  "settings.accountDescription": "Profil, zmena hesla",
  "settings.accountIntro": "Údaje týkajúce sa vášho účtu:",
  "settings.accountSection": "Účet",
  "settings.appearance": "Vzhľad",
  "settings.appearanceDescription": "Motív a možnosti zobrazenia",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "Arabsky",
  "settings.availableServices": "Dostupné",
  "settings.bulgarian": "Bulharčina",
  "settings.cannotDisconnectLastAccount": "Nie je možné odpojiť jedinú metódu prihlásenia. Najprv pridajte inú metódu prihlásenia.",
  "settings.changeEmail": "Zmeniť e-mail",
  "settings.changePassword": "Zmeniť heslo",
  "settings.chartGestures": "Gestá na grafoch",
  "settings.chartGesturesDescription": "Potiahnutím po grafoch sa zmení časové obdobie, stiahnutím grafov sa zmení časový rozsah",
  "settings.connect": "Pripojiť",
  "settings.connected": "Pripojené",
  "settings.connectedAccounts": "Prepojené účty",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Pripojené",
  "settings.connectedSince": "Pripojené od {date}",
  "settings.connectionSuccess": "Účet {provider} úspešne pripojený",
  "settings.contactUs": "Kontaktujte nás",
  "settings.contactUsDescription": "Získajte pomoc alebo pošlite spätnú väzbu",
  "settings.croatian": "Chorvátsky",
  "settings.currentPassword": "Aktuálne heslo",
  "settings.czech": "Česky",
  "settings.danish": "Dánsky",
  "settings.dark": "Tmavá téma",
  "settings.dataDisplay": "Zobrazenie údajov",
  "settings.dateAndTime": "Dátum a čas",
  "settings.disconnect": "Odpojiť",
  "settings.disconnectConfirmation": "Naozaj chcete odpojiť svoj účet {provider}?",
  "settings.disconnectionSuccess": "Účet {provider} úspešne odpojený",
  "settings.donateButton": "Prispieť darom",
  "settings.donateDescription": "SmartMixin vyvíja malý tím. Ak je pre vás užitočný, môžete podporiť jeho vývoj jednorazovým darom v ľubovoľnej výške. Je to dar — nemení váš plán ani neodomyká žiadne funkcie.",
  "settings.donateSuccessBody": "Váš dar pomáha udržať SmartMixin v prevádzke a zlepšovať ho. Veľmi si to vážime.",
  "settings.donateSuccessTitle": "Ďakujeme za vašu podporu!",
  "settings.donateTitle": "Podporte SmartMixin",
  "settings.dutch": "Holandsky",
  "settings.emailChange": "Zmeniť e-mailovú adresu",
  "settings.emailChangeConfirmation": "Potvrdenie zmeny e-mailu",
  "settings.emailChangeFailure": "Odkaz na zmenu e-mailu je neplatný alebo vypršal.",
  "settings.emailChangeSuccess": "Váš e-mail bol úspešne zmenený na {newEmail}.",
  "settings.emailChangeVerificationSent": "Na vašu novú e-mailovú adresu bol odoslaný overovací e-mail. Skontrolujte svoju doručenú poštu a kliknite na odkaz na potvrdenie zmeny.",
  "settings.english": "Anglicky",
  "settings.forecastModelOrderEmpty": "Žiadne uložené poradie — predvolene používame GFS.",
  "settings.forecastModelOrderFreeHint": "Prémiové modely vyžadujú predplatné SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Vyberáme prvý model vo vašom zozname, ktorý pokrýva danú stanicu.",
  "settings.forecastModelOrderReset": "Obnoviť predvolené",
  "settings.forecastModelOrderTitle": "Predvolený model predpovede",
  "settings.forecastModels": "Modely predpovede",
  "settings.forecastModelsDescription": "Zoradiť podľa preferencie",
  "settings.french": "Francúzsky",
  "settings.german": "Nemecky",
  "settings.gestures": "Gestá",
  "settings.greek": "Grécky",
  "settings.helpCenter": "Centrum pomoci",
  "settings.helpCenterDescription": "Často kladené otázky a návody",
  "settings.hungarian": "Maďarsky",
  "settings.integrationsSection": "Integrácie",
  "settings.italian": "Taliansky",
  "settings.japanese": "japončina",
  "settings.korean": "kórejský",
  "settings.language": "Jazyk",
  "settings.languageDescription": "Preferovaný jazyk",
  "settings.light": "Svetlá téma",
  "settings.newEmailAddress": "Nová e-mailová adresa",
  "settings.newPassword": "Nové heslo",
  "settings.newPasswordAgain": "Nové heslo znova",
  "settings.norwegian": "Nórsky",
  "settings.notConnected": "Nepripojené",
  "settings.notificationsSection": "Oznámenia",
  "settings.oldPassword": "Staré heslo",
  "settings.ongoingNotificationEnabled": "Povoliť trvalé oznámenie",
  "settings.ongoingNotificationMetrics": "Zobrazené metriky",
  "settings.ongoingNotificationMetricsHint": "Potiahnutím zmeníte poradie vybraných metrík",
  "settings.ongoingNotificationPermissionRequired": "Vyžaduje sa povolenie na oznámenia",
  "settings.ongoingNotificationStation": "Meteorologická stanica",
  "settings.passwordChange": "Zmena hesla",
  "settings.polish": "Poľsky",
  "settings.portuguese": "Portugalsky",
  "settings.preferencesSection": "Predvoľby",
  "settings.premium": "Prémium",
  "settings.premiumActive": "Aktívne",
  "settings.premiumAnnualThenPrice": "Potom 9,99 €/rok",
  "settings.premiumAnnualTrialInfo": "Začnite s bezplatnou skúšobnou dobou na {days} dní",
  "settings.premiumCurrentPlan": "Current Plan",
  "settings.premiumDescription": "Odomknite prémiové funkcie",
  "settings.premiumDownloadApp": "Download the app to subscribe:",
  "settings.premiumExpiresOn": "Renews on {date}",
  "settings.premiumFreePlan": "Free",
  "settings.premiumInactive": "Bez predplatného",
  "settings.premiumManageWebSubscription": "Spravujte svoje predplatné, aktualizujte spôsob platby alebo zrušte.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Ročne — 9,99 €/rok",
  "settings.premiumSubscribedOn": "Subscribed on {platform}",
  "settings.premiumSubscribeMonthly": "Mesačne — 1,99 €/mesiac",
  "settings.premiumSubscribeOnWeb": "Prihláste sa na odber a odomknite všetky prémiové funkcie.",
  "settings.premiumSubscriptionSuccess": "Vaše predplatné bolo aktivované! Užite si všetky prémiové funkcie.",
  "settings.premiumSubscriptionSuccessTitle": "Vitajte v Premium!",
  "settings.premiumWebappNotice": "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android.",
  "settings.privacyPolicy": "Zásady ochrany osobných údajov",
  "settings.profile": "Profil",
  "settings.russian": "ruský",
  "settings.serbian": "Srbsky",
  "settings.settings": "Nastavenia",
  "settings.slovak": "Slovenský",
  "settings.smallDecimals": "Malé desatinné",
  "settings.smallDecimalsDescription": "Zobraziť desatinné číslice v menšej veľkosti",
  "settings.socialConnectionsIntro": "Prepojte svoje sociálne účty pre rýchle prihlásenie. Účty môžete kedykoľvek pripojiť alebo odpojiť.",
  "settings.spanish": "Španielsky",
  "settings.statusBarWidget": "Widget stavového riadku",
  "settings.statusBarWidgetDescription": "Vždy viditeľné údaje o počasí",
  "settings.subscriptionSection": "Predplatné",
  "settings.supportSection": "Podpora",
  "settings.swedish": "Švédsky",
  "settings.systemTheme": "Systémová téma",
  "settings.termsOfService": "Podmienky poskytovania služby",
  "settings.turkish": "Turecký",
  "settings.ukrainian": "Ukrajinčina",
  "settings.units": "Jednotky",
  "settings.unitsDescription": "Merné jednotky zobrazené v rámci aplikácie",
  "settings.update": "Aktualizácia",
  "settings.updateYourProfile": "Aktualizujte svoj profil",
  "settings.weatherServices": "Meteorologické služby",
  "settings.weatherServicesConnected": "{count, plural, =0 {Žiadne pripojené služby} one {# pripojená služba} few {# pripojené služby} many {# pripojených služieb} other {# pripojených služieb}}",
  "settings.weatherServicesDescription": "Pripojte Netatmo, Davis, Weatherflow a ďalšie",
  "settings.windDirectionConvention": "Šípka smeru vetra",
  "settings.windDirectionConventionDescription": "Vyberte spôsob zobrazenia šípok smeru vetra",
  "settings.windDirectionMeteorological": "Smer pôvodu",
  "settings.windDirectionMeteorologicalDescription": "Šípka ukazuje, odkiaľ vietor fúka (konvencia meteorological)",
  "settings.windDirectionOceanographic": "Smer prúdenia",
  "settings.windDirectionOceanographicDescription": "Šípka ukazuje, kam vietor fúka (konvencia oceanographic)",
  "units.absolutePressure": "Absolútny tlak",
  "units.airDensity": "Hustota vzduchu",
  "units.airGap": "Vzduchová medzera",
  "units.apparentTemperature": "Zdanlivá teplota",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Priem.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Teplota čiernej gule",
  "units.boilerOn": "Kotol ZAPNUTÝ",
  "units.co2": "CO2",
  "units.coolingDegreeDays": "Ochladzovacie dni",
  "units.dailyHeatingDuration": "Denné trvanie vykurovania",
  "units.dailyPrecipitation": "Denné zrážky",
  "units.dailyRain": "Denný dážď",
  "units.degreeDay": "Prvý vykurovací deň",
  "units.degreeDayShort": "VD",
  "units.depth": "Hĺbka",
  "units.depthSensors": "Senzory hĺbky",
  "units.dewPoint": "Rosný bod",
  "units.distance": "Vzdialenosť",
  "units.downTrend": "dole",
  "units.E": "V",
  "units.E_long": "Východ",
  "units.ENE": "VSV",
  "units.ENE_long": "Východ-Severovýchod",
  "units.ESE": "VJV",
  "units.ESE_long": "Východ-Juhovýchod",
  "units.ET": "Evapotranspirácia",
  "units.ETshort": "ET",
  "units.feelLike": "Pocitovo",
  "units.feelsLike": "Pocitovo",
  "units.footMile": "Stopy, míle",
  "units.frostPoint": "Bod mrazu",
  "units.gust": "Nárazy vetra",
  "units.heatIndex": "Tepelný index",
  "units.heatingDegreeDays": "Vykurovacie dni",
  "units.heatingPower": "Výkon vykurovania",
  "units.humidex": "Humidex",
  "units.humidity": "Vlhkosť",
  "units.inch": "Palec",
  "units.inchOfMercury": "Palec ortuti",
  "units.kilometerPerHour": "Kilometre za hodinu",
  "units.knot": "Uzol",
  "units.last12Hours": "",
  "units.last24Hours": "",
  "units.last3Hours": "",
  "units.last6Hours": "",
  "units.lastHour": "Posledná hodina",
  "units.lastLightningImpact": "Posledný úder blesku",
  "units.lastMeasure": "Posledné meranie",
  "units.leafSensors": "Listové senzory",
  "units.leafWetness": "Vlhkosť listov",
  "units.lightningDistance": "Vzdialenosť",
  "units.lightningStrikeCount": "Počet úderov blesku",
  "units.lightningStrikeDistance": "Vzdialenosť úderu blesku",
  "units.max": "Max.",
  "units.max_gust": "Max. nárazy vetra",
  "units.max_wind": "Max. vietor",
  "units.meterKilometer": "Metre, kilometre",
  "units.meterPerSecond": "Metre za sekundu",
  "units.milePerHour": "Míle za hodinu",
  "units.millibar": "Milibar",
  "units.millimeter": "Milimeter",
  "units.millimeterOfMercury": "Milimeter ortuti",
  "units.min": "Min.",
  "units.N": "S",
  "units.N_long": "Sever",
  "units.NE": "SV",
  "units.NE_long": "Severovýchod",
  "units.NNE": "SSV",
  "units.NNE_long": "Sever-Severovýchod",
  "units.NNW": "SSZ",
  "units.NNW_long": "Sever-Severozápad",
  "units.noise": "Hluk",
  "units.normalizedHeatingCoefficient": "Normalizovaný koeficient vykurovania",
  "units.NW": "SZ",
  "units.NW_long": "Severozápad",
  "units.O3": "Ozón",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Zrážky",
  "units.pressure": "Tlak",
  "units.rain": "Dážď",
  "units.rainRate": "Intenzita dažďa",
  "units.referenceTemperature": "Referenčná teplota",
  "units.relativePressure": "Relatívny tlak",
  "units.S": "J",
  "units.S_long": "Juh",
  "units.SE": "JV",
  "units.SE_long": "Juhovýchod",
  "units.setPoint": "Určiť bod",
  "units.snow": "Sneh",
  "units.snowfall": "Sneženie",
  "units.soilMoisture": "Vlhkosť",
  "units.soilSensors": "Pôdne senzory",
  "units.solarEnergy": "Slnečná energia",
  "units.solarRadiation": "Slnečné žiarenie",
  "units.speed": "Rýchlosť",
  "units.SSE": "JJV",
  "units.SSE_long": "Juh-Juhovýchod",
  "units.SSW": "JJZ",
  "units.SSW_long": "Juh-Juhozápad",
  "units.stableTrend": "stabilný",
  "units.sum": "Súčet",
  "units.SW": "JZ",
  "units.SW_long": "Juhozápad",
  "units.temperature": "Teplota",
  "units.temperatureAndHumiditySensors": "Senzory teploty a vlhkosti",
  "units.temperatureSensors": "Senzory teploty a vlhkosti",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Dnes",
  "units.upTrend": "dole",
  "units.uv": "UV",
  "units.visibility": "Viditeľnosť",
  "units.W": "Z",
  "units.W_long": "Západ",
  "units.wetBulbGlobeTemperature": "Teplota mokrej gule.",
  "units.wetBulbTemperature": "Teplota vlhkého teplomera.",
  "units.wind": "Vietor",
  "units.windChill": "Ochladenie vetra",
  "units.windDirection": "Smer vetra",
  "units.windRun": "Priebeh vetra",
  "units.windRunDescription": "Priebeh vetra je celková vzdialenosť vetra za určité časové obdobie",
  "units.WNW": "ZSZ",
  "units.WNW_long": "Západ-Severozápad",
  "units.WSW": "ZJZ",
  "units.WSW_long": "Západ-Juhozápad"
}
